import Layout from "../components/Layout";
import { usePdtsContext, PdtsProvider } from "../context/PdtsContext";
import product_3 from "../../assets/websitePictures/Anchor series - Percale/Hotel Anchor serie - Percale-fitted sheets.jpg";
import product_1 from "../../assets/websitePictures/Endure Series/Premier-bedding.jpg";
import { useNavigate } from "react-router-dom";
import { getBkendUrl, getRootUrl } from "../../consts";
import { useState } from "react";
import { useCartContext } from "../context/CartContext";
import { Link } from "react-router-dom";
import { useSearchContext } from "../context/SearchContext";

function PdtListItem({pdt, addItem, addWishListItem, removeWishListItem, inWishList}){
  const [cases, setCases] = useState(1);
  const rootUrl = getRootUrl();

  return <tr
    key={pdt.__id}
    
  >
    <td className="py-3">
      <img src={pdt.images[0].url} alt="Product" className="img-fluid rounded" loading="lazy" style={{
        "width": "75px",
        "height": "75px"
      }}/>
    </td>
    <td className="p-3">{`[${pdt.sn}] ${pdt.name}`}</td>
    <td>{pdt.price}</td>
    <td>{pdt.unitsPerCase}</td>
    <td>{pdt.price*pdt.unitsPerCase}</td>
    <td>
      <div className="col-lg-3 col-12 mt-3 mt-lg-0 text-center">
        <div className="quantity-selector d-flex">
          <button className="quantity-btn decrease btn"
            onClick={evt=>setCases(prev=>Math.max(1, prev-1))}
          >
            <i className="bi bi-dash"></i>
          </button>
            <input _type="number" className="quantity-input text-center" value={cases} _min="1" _max="10"
              min-length={3}
              max-length={5}
              style={{"width":"3em"}} 
              onChange={evt=>setCases(cases, evt.target.value)}
            />
          <button className="quantity-btn increase btn"
            onClick={evt=>setCases(prev=>Math.max(1, prev+1))}
          >
            <i className="bi bi-plus"></i>
          </button>
        </div>
      </div>

    </td>
    <td className="text-alignment-center">
      <Link className="remove-item ms-3" type="button"
        title={"view detail"}
        to={`${rootUrl}/wwapp/productdetails/${pdt.__id}`}
      ><i className="bi bi-eye"></i>
      </Link><br />
      <button
        type="button"
        className="btn" data-bs-toggle="tooltip"
        title="Add to Cart"
        onClick={evt=>pdt.unitsPerCase&&addItem(pdt, cases * (pdt.unitsPerCase || 10))}
      >
        <i className="bi bi-cart-plus"></i>
      </button><br />
      <button
        type="button"
        className="btn" data-bs-toggle="tooltip"
        title={inWishList(pdt)?"remove from wishlist":"Add to wishlist"}
        onClick={evt=>inWishList(pdt)?removeWishListItem(pdt.__id):addWishListItem(pdt)}
      >
        {inWishList(pdt)?<i className="bi bi-bag-heart-fill me-2"></i>:<i className="bi bi-bag-heart me-2"></i>}
      </button>
    </td>

  </tr>
}

function ProductContent(){
  const [page, setPage] = useState(0);
  const [pageLength, setPageLength] = useState(12);
  const [view, setView] = useState('list');
  const { pdtCategories, products, category, setCategory } = usePdtsContext();
  const navigate = useNavigate();
  const rootUrl = getRootUrl();
  const {addItem, addWishListItem, removeWishListItem, inWishList} = useCartContext();
  const {searchStr, setSearchStr} = useSearchContext();

  
  const tgtProducts = searchStr?products.filter(pdt=>{
    const r = RegExp(searchStr, 'i');
    const pdtCaption = `${pdt.sn}-${pdt.name}-${pdt.brandAbbr}`;
    console.log(searchStr, pdtCaption, r.test(pdtCaption));
    return r.test(pdtCaption);
  }):products;

  return <div style={{"background":"white"}}>
      {/* <!-- Page Title --> */}
      <div className="page-title light-background">
        <div className="container d-lg-flex justify-content-between align-items-center">
          <h1 className="mb-2 mb-lg-0">Products</h1>
          <nav className="breadcrumbs">
            <ol>
              <li><Link
                to={`${rootUrl}/wwapp`}
              >Home</Link></li>
              <li className="current">Products</li>
            </ol>
          </nav>
        </div>
      </div>
      {/* <!-- End Page Title --> */}

      <div className="container">
        <div className="row">

          <div className="col-lg-3 sidebar ps-0 pe-3">

            <div className="widgets-container">

              {/* <!-- Product Categories Widget --> */}
              <div className="product-categories-widget widget-item position-sticky">

                <h3 className="widget-title">Categories</h3>

                <ul className="category-tree list-unstyled mb-0">

                  {[{ caption: 'All Categories'}, ...pdtCategories].map(cat=><li
                    // key={cat.caption.replace(/ /g, '_')}
                    key={Math.random()}
                    className="category-item"
                  >
                    <div
                      className="d-flex justify-content-between align-items-center category-header collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target={`#cat-${cat.caption.replace(/ /g, '_')}`}
                      aria-expanded="false"
                      aria-controls={`cat-${cat.caption.replace(/ /g, '_')}`}
                      style={{"padding":"0"}}
                    >
                      <a href="#" className="category-link pe-3"
                        onClick={evt=>{
                          // const idxCat = category.find(c=>c==cat);
                          
                          // if(idxCat){
                          //   setCategory(...category.slice(idxCat-1, idxCat));
                          // }else{
                          //   setCategory([...category, cat.caption]);
                          // }
                          if(cat.caption == 'All Categories'){
                            setCategory([]);
                          }else{
                            setCategory([cat.caption]);
                          }
                            
                        }}
                      >{cat.caption}</a>
                      {((cat.subs||[]).length>0)&&<span className="category-toggle">
                        <i className="bi bi-chevron-down"></i>
                        <i className="bi bi-chevron-up"></i>
                      </span>}
                    </div>
                    {((cat.subs||[]).length>0)&&<ul id={`cat-${cat.caption.replace(/ /g, '_')}`} className="subcategory-list list-unstyled collapse ps-3 mt-2">
                      {(cat.subs||[]).map(sub=><li
                        key={Math.random()}
                        onClick={evt=>{
                          setCategory([sub.caption]);
                        }}
                      ><a href="#" className="subcategory-link">{sub.caption}</a></li>)}
                    </ul>}
                  </li>)}

                </ul>

              </div>
              {/* <!--/Product Categories Widget --> */}

              {/* <!-- Pricing Range Widget --> */}
              {/* <div className="pricing-range-widget widget-item">

                <h3 className="widget-title">Price Range</h3>

                <div className="price-range-container">
                  <div className="current-range mb-3">
                    <span className="min-price">$0</span>
                    <span className="max-price float-end">$1000</span>
                  </div>

                  <div className="range-slider">
                    <div className="slider-track"></div>
                    <div className="slider-progress"></div>
                    <input type="range" className="min-range" min="0" max="1000" _value="0" step="10" />
                    <input type="range" className="max-range" min="0" max="1000" _value="500" step="10" />
                  </div>

                  <div className="price-inputs mt-3">
                    <div className="row g-2">
                      <div className="col-6">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">$</span>
                          <input type="number" className="form-control min-price-input" placeholder="Min" min="0" max="1000" _value="0" step="10" />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">$</span>
                          <input type="number" className="form-control max-price-input" placeholder="Max" min="0" max="1000" _value="500" step="10" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="filter-actions mt-3">
                    <button type="button" className="btn btn-sm btn-primary w-100">Apply Filter</button>
                  </div>
                </div>

              </div> */}
              {/* <!--/Pricing Range Widget --> */}

              {/* <!-- Brand Filter Widget --> */}
              {/* <h3 className="brand-filter-widget widget-item">Filter by Brand</h3> */}
              {/* <!--/Brand Filter Widget --> */}

              {/* <!-- Color Filter Widget --> */}
              {/* <div className="color-filter-widget widget-item">

                <h3 className="widget-title">Filter by Color</h3>

                <div className="color-filter-content">
                  <div className="color-options">
                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="black" id="color-black" />
                      <label className="form-check-label" htmlFor="color-black">
                        <span className="color-swatch" style={{"backgroundColor": "#000000"}} title="Black"></span>
                      </label>
                    </div>

                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="white" id="color-white" />
                      <label className="form-check-label" htmlFor="color-white">
                        <span className="color-swatch" style={{"backgroundColor": "#ffffff"}} title="White"></span>
                      </label>
                    </div>

                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="red" id="color-red" />
                      <label className="form-check-label" htmlFor="color-red">
                        <span className="color-swatch" style={{"backgroundColor": "#e74c3c"}} title="Red"></span>
                      </label>
                    </div>

                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="blue" id="color-blue" />
                      <label className="form-check-label" htmlFor="color-blue">
                        <span className="color-swatch" style={{"backgroundColor": "#3498db"}} title="Blue"></span>
                      </label>
                    </div>

                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="green" id="color-green" />
                      <label className="form-check-label" htmlFor="color-green">
                        <span className="color-swatch" style={{"backgroundColor": "#2ecc71"}} title="Green"></span>
                      </label>
                    </div>

                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="yellow" id="color-yellow" />
                      <label className="form-check-label" htmlFor="color-yellow">
                        <span className="color-swatch" style={{"backgroundColor": "#f1c40f"}} title="Yellow"></span>
                      </label>
                    </div>

                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="purple" id="color-purple" />
                      <label className="form-check-label" htmlFor="color-purple">
                        <span className="color-swatch" style={{"backgroundColor": "#9b59b6"}} title="Purple"></span>
                      </label>
                    </div>

                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="orange" id="color-orange" />
                      <label className="form-check-label" htmlFor="color-orange">
                        <span className="color-swatch" style={{"backgroundColor": "#e67e22"}} title="Orange"></span>
                      </label>
                    </div>

                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="pink" id="color-pink" />
                      <label className="form-check-label" htmlFor="color-pink">
                        <span className="color-swatch" style={{"backgroundColor": "#fd79a8"}} title="Pink"></span>
                      </label>
                    </div>

                    <div className="form-check color-option">
                      <input className="form-check-input" type="checkbox" _value="brown" id="color-brown" />
                      <label className="form-check-label" htmlFor="color-brown">
                        <span className="color-swatch" style={{"backgroundColor": "#795548"}} title="Brown"></span>
                      </label>
                    </div>
                  </div>

                  <div className="filter-actions mt-3">
                    <button type="button" className="btn btn-sm btn-outline-secondary">Clear All</button>
                    <button type="button" className="btn btn-sm btn-primary">Apply Filter</button>
                  </div>
                </div>

              </div> */}
              {/* <!--/Color Filter Widget --> */}

              {/* <!-- Brand Filter Widget --> */}
              {/* <div className="brand-filter-widget widget-item">

                <h3 className="widget-title">Filter by Brand</h3>

                <div className="brand-filter-content">
                  <div className="brand-search">
                    <input type="text" className="form-control" placeholder="Search brands..." />
                    <i className="bi bi-search"></i>
                  </div>

                  <div className="brand-list">
                    <div className="brand-item">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="brand1" />
                        <label className="form-check-label" htmlFor="brand1">
                          Nike
                          <span className="brand-count">(24)</span>
                        </label>
                      </div>
                    </div>

                    <div className="brand-item">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="brand2" />
                        <label className="form-check-label" htmlFor="brand2">
                          Adidas
                          <span className="brand-count">(18)</span>
                        </label>
                      </div>
                    </div>

                    <div className="brand-item">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="brand3" />
                        <label className="form-check-label" htmlFor="brand3">
                          Puma
                          <span className="brand-count">(12)</span>
                        </label>
                      </div>
                    </div>

                    <div className="brand-item">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="brand4" />
                        <label className="form-check-label" htmlFor="brand4">
                          Reebok
                          <span className="brand-count">(9)</span>
                        </label>
                      </div>
                    </div>

                    <div className="brand-item">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="brand5" />
                        <label className="form-check-label" htmlFor="brand5">
                          Under Armour
                          <span className="brand-count">(7)</span>
                        </label>
                      </div>
                    </div>

                    <div className="brand-item">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="brand6" />
                        <label className="form-check-label" htmlFor="brand6">
                          New Balance
                          <span className="brand-count">(6)</span>
                        </label>
                      </div>
                    </div>

                    <div className="brand-item">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="brand7" />
                        <label className="form-check-label" htmlFor="brand7">
                          Converse
                          <span className="brand-count">(5)</span>
                        </label>
                      </div>
                    </div>

                    <div className="brand-item">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="brand8" />
                        <label className="form-check-label" htmlFor="brand8">
                          Vans
                          <span className="brand-count">(4)</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="brand-actions">
                    <button className="btn btn-sm btn-outline-primary">Apply Filter</button>
                    <button className="btn btn-sm btn-link">Clear All</button>
                  </div>
                </div>

              </div> */}
              {/* <!--/Brand Filter Widget --> */}

            </div>

          </div>

          <div className="col-lg-9">

            {/* <!-- Category Header Section --> */}
            <section id="category-header" className="category-header section">

              <div className="container" data-aos="fade-up">

                {/* <!-- Filter and Sort Options --> */}
                <div className="filter-container mb-4" data-aos="fade-up" data-aos-delay="100" style={{"padding":"0"}}>
                  <div className="row g-3">
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="filter-item search-form">
                        <label htmlFor="productSearch" className="form-label">Search Products</label>
                        <form className="input-group"
                          onSubmit={evt=>{
                              // evt.stopPropagation();
                              evt.preventDefault();
                              const { elements } = evt.target;   // same as `form.elements`
                              const searchStr = elements.searchStr.value; // `name` attribute → property
                              setSearchStr(searchStr);
                          }}       
                        >
                          <input name="searchStr" type="text" className="form-control" id="productSearch" placeholder="Search for products..." aria-label="Search for products" />
                          <button className="btn search-btn" type="submit">
                            <i className="bi bi-search"></i>
                          </button>
                        </form>
                      </div>
                    </div>

                    {/* <div className="col-12 col-md-6 col-lg-2">
                      <div className="filter-item">
                        <label htmlFor="priceRange" className="form-label">Price Range</label>
                        <select className="form-select" id="priceRange">
                          <option _value="">All Prices</option>
                          <option>Under $25</option>
                          <option>$25 to $50</option>
                          <option>$50 to $100</option>
                          <option>$100 to $200</option>
                          <option>$200 &amp; Above</option>
                        </select>
                      </div>
                    </div> */}

                    {/* <div className="col-12 col-md-6 col-lg-2">
                      <div className="filter-item">
                        <label htmlFor="sortBy" className="form-label">Sort By</label>
                        <select className="form-select" id="sortBy">
                          <option _value="">Featured</option>
                          <option>Price: Low to High</option>
                          <option>Price: High to Low</option>
                          <option>Customer Rating</option>
                          <option>Newest Arrivals</option>
                        </select>
                      </div>
                    </div> */}

                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="filter-item">
                        <label className="form-label">View</label>
                        <div className="d-flex align-items-center">
                          <div className="view-options me-3">
                            <button type="button" className={"btn view-btn "+(view=='grid'?' active ':'')} data-view="grid" aria-label="Grid view"
                              onClick={evt=>setView('grid')}
                            >
                              <i className="bi bi-grid-3x3-gap-fill"></i>
                            </button>
                            <button type="button" className={"btn view-btn "+(view=='list'?' active ':'')} data-view="list" aria-label="List view"
                              onClick={evt=>setView('list')}
                            >
                              <i className="bi bi-list-ul"></i>
                            </button>
                          </div>
                          <div className="items-per-page">
                            <select className="form-select" id="itemsPerPage" aria-label="Items per page"
                              value={pageLength}
                              onChange={evt=>{
                                setPageLength(evt.target.value);
                              }}
                            >
                              <option value="6">6 per page</option>
                              <option value="12">12 per page</option>
                              <option value="24">24 per page</option>
                              <option value="48">48 per page</option>
                              <option value="96">96 per page</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="row mt-3">
                    <div className="col-12" data-aos="fade-up" data-aos-delay="200">
                      <div className="active-filters">
                        <span className="active-filter-label">Active Filters:</span>
                        <div className="filter-tags">
                          <span className="filter-tag">
                            Electronics <button className="filter-remove"><i className="bi bi-x"></i></button>
                          </span>
                          <span className="filter-tag">
                            $50 to $100 <button className="filter-remove"><i className="bi bi-x"></i></button>
                          </span>
                          <button className="clear-all-btn">Clear All</button>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div className="row mt-3">
                     {(category.length>0)&&<p><strong>categories: </strong> {category.map(cat=><span>{cat}</span>)}</p>}
                    
                  </div>
                
                </div>

              </div>

            </section>
            {/* <!-- /Category Header Section --> */}

            {/* <!-- Category Product List Section --> */}
            <section id="category-product-list" className="category-product-list section">

              <div className="container" data-aos="fade-up" data-aos-delay="100">

                {(view=='grid')&&<div className="row g-4">
                  {/* <!-- Product 1 --> */}

                    {/* [] products is supplied by provider and is persist if provider is not reload */}
                    {tgtProducts.slice(page*pageLength, (page+1)*pageLength).map(pdt=>{
                      console.log('page, pagelength:', page, pageLength);
                      const imgUrl = pdt.images[0].url;
                      const pdtCaption = `[${pdt.sn}] ${pdt.name}`;
                      return <div 
                        key={pdt.__id}
                        className="col-6 col-xl-4"
                      >
                        {/* <div>{pdt.__id} / {imgUrl}</div> */}
                        <div className="product-card" data-aos="zoom-in">
                          <div className="product-image">
                            <img src={imgUrl} className="main-image img-fluid" alt={pdtCaption} />
                            <img src={imgUrl} className="hover-image img-fluid" alt={pdtCaption} />
                            <div className="product-overlay">
                              <div className="product-actions">

                                <button type="button" className="action-btn" data-bs-toggle="tooltip" title="View Detail"
                                  onClick={evt=>{
                                    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                                    navigate(`${rootUrl}/wwapp/productdetails/${pdt.__id}`);
                                  }}
                                >
                                  <i className="bi bi-eye"></i>
                                </button>
                                <button type="button" className="action-btn" data-bs-toggle="tooltip" title={inWishList(pdt)?"remove from wishlist":"add to wishlist"}
                                  onClick={evt=>{
                                    inWishList(pdt)?removeWishListItem(pdt.__id):addWishListItem(pdt)
                                  }}
                                >
                                  {inWishList(pdt)?<i className="bi bi-bag-heart-fill"></i>:<i className="bi bi-bag-heart"></i>}
                                </button>

                                <button
                                  type="button" className="action-btn" data-bs-toggle="tooltip"
                                  title="Add to Cart"
                                  onClick={evt=>addItem(pdt)}
                                >
                                  <i className="bi bi-cart-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="product-details">
                            <div className="product-category">{pdt.pdtCat}</div>
                            <h4 className="product-title"><a href="product-details.html">{pdtCaption}</a></h4>
                            <div className="product-meta">
                              {pdt.price&&<div className="product-price">${pdt.price}</div>}
                              {/* <div className="product-rating">
                                <i className="bi bi-star-fill"></i>
                                4.8 <span>(42)</span>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>;}
                    )}
                    
                </div>}

                {(view=='list')&&<div className="row g-4">


                  <table  className="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Product Code</th>
                        <th>Unit Price</th>
                        <th>Units / Case</th>
                        <th>Price / Case</th>
                        <th className="text-center">Cases</th>
                        <th></th>
                      </tr>

                    </thead>
                    <tbody>
                      {tgtProducts.slice(page*pageLength, (page+1)*pageLength).map(pdt=><PdtListItem
                        key={pdt.__id}
                        pdt={pdt}
                        addItem={addItem}
                        addWishListItem = {addWishListItem}
                        removeWishListItem = {removeWishListItem}
                        inWishList={inWishList}
                      ></PdtListItem>)}
                    </tbody>
                    <tfoot></tfoot>
                  </table>
                  
                </div>}

              </div>

            </section>
            {/* <!-- /Category Product List Section --> */}

            {/* <!-- Category Pagination Section --> */}
            <section id="category-pagination" className="category-pagination section">

              <div className="container">
                <nav className="d-flex justify-content-center" aria-label="Page navigation">
                  <ul>
                    <li>
                      <a href="#" aria-label="Previous page">
                        <i className="bi bi-arrow-left"></i>
                        <span className="d-none d-sm-inline"
                          onClick={evt=>setPage(Math.max(0, page-1))}
                        >Previous</span>
                      </a>
                    </li>
                    
                    {' '.repeat(Math.ceil(tgtProducts.length/pageLength)).split('').map((_, idx)=><li
                      key={idx}
                      
                      onClick={evt=>setPage(idx)}
                    ><a href="#" className={idx==page?"active":''}>{idx+1}</a></li>)}
                    {/* <li><a href="#" className="active">1</a></li>
                    <li><a href="#">2</a></li>
                    <li><a href="#">3</a></li>
                    <li className="ellipsis">...</li>
                    <li><a href="#">8</a></li>
                    <li><a href="#">9</a></li>
                    <li><a href="#">10</a></li> */}

                    <li>
                      <a href="#" aria-label="Next page">
                        <span className="d-none d-sm-inline"
                          onClick={evt=>setPage(Math.min(Math.ceil(tgtProducts.length/pageLength)-1, page+1))}
                        >Next</span>
                        <i className="bi bi-arrow-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>

            </section>
            {/* <!-- /Category Pagination Section --> */}

          </div>

        </div>
      </div>  
  </div>;
}

export default function Product(){
    return <Layout><PdtsProvider>
      <ProductContent></ProductContent>
    </PdtsProvider></Layout>
}